/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Hex from 'solis/type/hex';

import { makeTransform } from 'solis/type/hex/transform';


export const HexID = (cass) =>
{
  return { ...cass, id: new Hex(cass.id) };
};


export const Transform = (cass) =>
{
  return { ...cass, transform: cass.transform ? makeTransform(new Hex(cass.transform.offset), cass.transform.rotation) : null };
};


export const HexTargetZone = (cass) =>
{
  return { ...cass, targetZone: new Hex(cass.targetZone) };
};
